import React from 'react';
import { Row } from 'react-bootstrap';

import FilterSelect from '../../components/FilterSelect';

const ADVANCED_ACCOUNT_FILTER_OPTIONS = {
  0: 'Show',
  1: 'Hide',
}

export default function AdvancedAccountFilteringPopover(props) {
  const { organization_id, setAccountSummaryFilterValue, setAccountOldFilterValue, setAccountIgnoreFilterValue, setAccountEmptyFilterValue } = props;

  return <>
    <Row>
      <FilterSelect
        label='Show Ignored Accounts'
        options={ADVANCED_ACCOUNT_FILTER_OPTIONS}
        setFilterValue={setAccountIgnoreFilterValue}
        size={12}
        organization_id={organization_id}
        preference_key={'aif'}
        empty_preference={'0'}
      />
    </Row>
    <Row>
      <FilterSelect
        label='Show Summary Accounts'
        options={ADVANCED_ACCOUNT_FILTER_OPTIONS}
        setFilterValue={setAccountSummaryFilterValue}
        size={12}
        organization_id={organization_id}
        preference_key={'asf'}
        empty_preference={'0'}
      />
    </Row>
    <Row>
      <FilterSelect
        label='Show Old Accounts'
        options={ADVANCED_ACCOUNT_FILTER_OPTIONS}
        setFilterValue={setAccountOldFilterValue}
        size={12}
        organization_id={organization_id}
        preference_key={'aof'}
        empty_preference={'0'}
      />
    </Row>
    <Row>
      <FilterSelect
        label='Show Empty Accounts'
        options={ADVANCED_ACCOUNT_FILTER_OPTIONS}
        setFilterValue={setAccountEmptyFilterValue}
        size={12}
        organization_id={organization_id}
        preference_key={'aef'}
        empty_preference={'0'}
      />
    </Row>
  </>
}